var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center","justify":"center"}},[_c('header-admiral',{attrs:{"instance":_vm.instance,"activeDocument":_vm.activeDocument,"action":_vm.action,"message":_vm.message,"color-background":_vm.colorBackground},on:{"update:message":function($event){return _vm.updateMessage($event)}}}),_c('email-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }